import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  style: {"width":"100%","position":"relative"},
  class: "pa-2"
}
const _hoisted_2 = {
  style: {"width":"100%","overflow-x":"auto"},
  class: "scrollbar-hidden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleComponent = _resolveComponent("TitleComponent")!
  const _component_TableComponent = _resolveComponent("TableComponent")!
  const _component_ChartComponent = _resolveComponent("ChartComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TitleComponent, {
      box: _ctx.box,
      text: _ctx.box.reportProperties.title
    }, null, 8, ["box", "text"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.uiType === 'table')
        ? (_openBlock(), _createBlock(_component_TableComponent, {
            key: 0,
            tableTheme: _ctx.tableTheme,
            tableData: _ctx.tableData
          }, null, 8, ["tableTheme", "tableData"]))
        : (_ctx.uiType === 'chart')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.box.chartData)
                ? (_openBlock(), _createBlock(_component_ChartComponent, {
                    key: 0,
                    data: _ctx.box.chartData,
                    options: _ctx.box.chartOptions,
                    chartType: _ctx.themeChartType
                  }, null, 8, ["data", "options", "chartType"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.uiType === 'card')
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.cardTag), _normalizeProps(_mergeProps({ key: 2 }, _ctx.cardProps)), null, 16))
            : _createCommentVNode("", true)
    ])
  ]))
}